import { render, staticRenderFns } from "./ProductsRenewalPlans.vue?vue&type=template&id=0d06fb2c&scoped=true"
import script from "./ProductsRenewalPlans.vue?vue&type=script&lang=js"
export * from "./ProductsRenewalPlans.vue?vue&type=script&lang=js"
import style0 from "./ProductsRenewalPlans.vue?vue&type=style&index=0&id=0d06fb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06fb2c",
  null
  
)

export default component.exports